/**
 * Première URL non vide, débarrassée de ses blancs.
 *
 * `null` et `undefined` sont ignorés de la même façon : le CMS peut aussi bien
 * envoyer `null` que ne pas envoyer la clé du tout (MIL-6901).
 */
export function firstNonEmptyUrl(...candidates: (string | null | undefined)[]): string | undefined {
  for (const url of candidates) {
    const trimmed = url?.trim();
    if (trimmed) return trimmed;
  }

  return undefined;
}
